import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({providedIn: 'root'})
export class LoaderService {
    isLoading: Subject<boolean> = new Subject<boolean>()
    constructor(private ngZone : NgZone ) { }
    
    show() {
        this.ngZone.run(() => {
            this.isLoading.next(true);
        });
    }

    hide() {
        this.ngZone.run(() => {
            this.isLoading.next(false);
        });
    }
}